window.ReportsAPI = new function () {

    var self = this;
    var _protected = BaseAPI.call(self);

    _protected.setApiUrl(publicConfiguration.getBaseAPI("ReportsServers"));

    self.liveVacancies = function (brandId, payload) {
        var deferred = $q.defer();

        _protected.request('brands/' + brandId + '/reports/live_vacancies/generate', 'POST', payload)
            .then(function (res) {
                if (res && res.data) {

                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };


    self.filledVacancies = function (brandId, payload) {
        var deferred = $q.defer();

        _protected.request('brands/' + brandId + '/reports/filled_vacancies/generate', 'POST', payload)
            .then(function (res) {
                if (res && res.data) {

                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.talentBank = function (brandId, payload) {
        var deferred = $q.defer();

        _protected.request('brands/' + brandId + '/reports/talent_bank/generate', 'POST', payload)
            .then(function (res) {
                if (res && res.data) {

                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.timeInWorkflow = function (brandId, payload) {
        var deferred = $q.defer();

        _protected.request('brands/' + brandId + '/reports/time_in_workflow/generate', 'POST', payload)
            .then(function (res) {
                if (res && res.data) {

                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.unfilledVacancies = function (brandId, payload) {
        var deferred = $q.defer();

        _protected.request('brands/' + brandId + '/reports/unfilled_vacancies/generate', 'POST', payload)
            .then(function (res) {
                if (res && res.data) {

                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.getBrandEEOReport = function (groupId, params) {
        var deferred = $q.defer();

        _protected.request('brands/' + groupId + '/reports/eeo', 'GET', params)
            .then(function (res) {

                if (res && res.data) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }
            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.generateGPEEOReport = function (groupId, params) {
        var deferred = $q.defer();

        _protected.request('brands/' + groupId + '/reports/eeo/generate', 'POST', params)
            .then(function (res) {
                if (res && res.data) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }
            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };
};